// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");
let AuthenticatedComponentRelay = require("./AuthenticatedComponentRelay.bs.js");

function RequireAuthenticatedAgent(props) {
  let children = props.children;
  return JsxRuntime.jsx(AuthenticatedComponentRelay.make, {
    requiredUserRole: "agent",
    renderWrappedComponent: () => children,
    loaderComponent: props.loaderComponent
  });
}

let make = RequireAuthenticatedAgent;

exports.make = make;
/* react/jsx-runtime Not a pure module */
